import { render, staticRenderFns } from "./NormalSearchNav154.vue?vue&type=template&id=0632ade6&scoped=true"
import script from "./NormalSearchNav154.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav154.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632ade6",
  null
  
)

export default component.exports